module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: ['icon', _vm.sizeClass],
    attrs: {
      "tabindex": "-1",
      "focusable": "false"
    }
  }, [_c('use', _vm._b({}, 'use', {
    'xlink:href': _vm.symbolName
  }, false))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0ee800a4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ee800a4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/icon/index.vue
// module id = 508
// module chunks = 7